import { atom, useAtom } from "jotai";
import { createContext } from "react";

export const organizationIdAtom = atom(null);
export const navAtom = atom(1)
export const showOnboardingModalAtom = atom(false);
console.log(navAtom)

export const NavbarContext = createContext(1);
